import { z } from 'zod';
/**
 * Estado del picking de un pedido en el middleware (F9), una fila por pedido de
 * Janis en `picking_state`.
 *
 * - `in_progress`: el WMS lo recibio o lo esta pickeando.
 * - `complete`: el WMS lo pickeo entero; falta confirmarlo en Janis.
 * - `shortage`: el WMS lo cerro con faltante. Queda en intervencion.
 * - `cancelled`: el WMS anulo la orden de despacho.
 * - `picked`: el picking quedo confirmado en Janis. Terminal, y lo pone F9:
 *   ningun aviso del WMS lo produce.
 */
export const PICKING_STATE_STATUSES = [
    'in_progress',
    'complete',
    'shortage',
    'cancelled',
    'picked',
];
export const pickingStateStatusSchema = z.enum(PICKING_STATE_STATUSES);
/** Estado que deja un aviso del WMS. Pura. */
export function pickingStateFor(estadoPedido) {
    switch (estadoPedido) {
        case 'RECIBIDO':
        case 'EN_PICKING':
            return 'in_progress';
        case 'PICKEADO':
            return 'complete';
        case 'PICKEADO_CON_FALTANTE':
            return 'shortage';
        case 'ANULADO':
            return 'cancelled';
    }
}
//# sourceMappingURL=picking-state.js.map